import { API_URL } from "../utility/constants";


export async function getKc(token, pedagogy_id) {
    try {
        const response = await fetch(API_URL + "courses/kc/getKc?pedagogy_id=" + pedagogy_id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function addKc(token, data) {
    try {
        const response = await fetch(API_URL + `courses/kc/addKc`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function addKcAnswer(token, data) {
    try {
        const response = await fetch(API_URL + `courses/kc/addKcAnswer`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function updateKc(token, data) {
    try {
        const response = await fetch(API_URL + `courses/kc/updateKc`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function deleteKc(token, kc_id) {
    try {
        const response = await fetch(API_URL + "courses/kc/deleteKc?kc_id=" + kc_id, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};